module.exports = __webpack_public_path__ + "static/media/square4.8b4e82c5.jpg";